// frontend/src/pages/Members.js

import React, { useEffect, useState } from "react";
import api from "../api/api";
import MemberCard from "../components/MemberCard";
import "../styles/members.css";

const Members = () => {

  /* =====================================================
     STATE MANAGEMENT
  ===================================================== */
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  /* =====================================================
     FETCH MEMBERS FROM DJANGO API
  ===================================================== */
  useEffect(() => {

    const fetchMembers = async () => {

      try {

        const res = await api.get("members/");

        if (res && Array.isArray(res.data)) {

          const updatedMembers = res.data.map((member) => {

            if (member.designation === "CEO") {
              return {
                ...member,
                designation: "CHIEF EXECUTIVE OFFICER (CEO)"
              };
            }

            return member;

          });

          setMembers(updatedMembers);

        } else {
          setMembers([]);
        }

      } catch (err) {

        console.error("Failed to fetch members:", err);
        setError("Failed to load members. Please try again later.");

      } finally {

        setLoading(false);

      }
    };

    fetchMembers();

  }, []);


  /* =====================================================
     LOADING STATE
  ===================================================== */
  if (loading) {
    return (
      <div className="app">
        <div className="section-wrapper">
          <p className="member-loading">Loading members...</p>
        </div>
      </div>
    );
  }


  /* =====================================================
     ERROR STATE
  ===================================================== */
  if (error) {
    return (
      <div className="app">
        <div className="section-wrapper">
          <p className="member-error">{error}</p>
        </div>
      </div>
    );
  }


  /* =====================================================
     EMPTY STATE
  ===================================================== */
  if (!members || members.length === 0) {
    return (
      <div className="app">
        <div className="section-wrapper">
          <p className="member-empty">No members found</p>
        </div>
      </div>
    );
  }


  /* =====================================================
     MAIN MEMBERS PAGE
  ===================================================== */
  return (
    <div className="app">

      <div className="section-wrapper">

        {/* Page Title */}
        <h1 className="members-title">
          Our Team
        </h1>

        {/* Members Grid */}
        <div className="members-grid">

          {members.map((member) => (
            <MemberCard
              key={member.id}
              member={member}
            />
          ))}

        </div>

      </div>

    </div>
  );
};

export default Members;